'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadl';
var iconName = 'door-open';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'f52b';
var svgPathData = ['M64 64l0 416 224 0 0-416c0-17.7-14.3-32-32-32L96 32C78.3 32 64 46.3 64 64zM248 248a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z', 'M96 32C78.3 32 64 46.3 64 64l0 416 224 0 0-416c0-17.7-14.3-32-32-32L96 32zm215.4 0c5.4 9.4 8.6 20.3 8.6 32l0 448-304 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l16 0 0-416C32 28.7 60.7 0 96 0L352 0c35.3 0 64 28.7 64 64l0 416 16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0c-8.8 0-16-7.2-16-16l0-432c0-17.7-14.3-32-32-32l-40.6 0zM248 248a24 24 0 1 1 -48 0 24 24 0 1 1 48 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faDoorOpen = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;